import {
  FETCH_DISTRICS_LIST_REQUEST,
  FETCH_DISTRICS_LIST_SUCCESS,
  FETCH_DISTRICS_LIST_FAILURE,
  SET_CURRENT_DISTRICT,
  FETCH_PREFIXES_REQUEST,
  FETCH_PREFIXES_SUCCESS,
  FETCH_PREFIXES_FAIL,
} from '../constants';

const initialState = {
  districts: {
    districtsList: null,
    areFetchingDistricts: false,
    areDistrictsFetched: false,
    currentDistrict: null,
  },
  arePrefixesFetched: false,
  prefixes: [],
};

const fetchDistrictRequest = state => ({
  ...state,
  districts: {
    Districts: null,
    areFetchingDistricts: true,
  },
});
const fetchDistrictSuccess = (state, action) => ({
  ...state,
  districts: {
    ...state.districts,
    districtsList: action.payload,
    areFetchingDistricts: false,
    areDistrictsFetched: true,
  },
});

const setCurrentDistrict = (state, action) => ({
  ...state,
  districts: {
    ...state.districts,
    currentDistrict: { ...action.payload },
  },
});

const fetchDistrictFailure = state => ({
  ...state,
  districts: {
    areFetchingDistricts: false,
    areDistrictsFetched: false,
  },
});

const fetchPrefixesRequest = state => ({
  ...state,
  arePrefixesFetched: false,
});
const fetchPrefixesSuccess = (state, action) => ({
  ...state,
  arePrefixesFetched: true,
  prefixes: [...action.payload],
});
const fetchPrefixesFail = state => ({
  ...state,
  arePrefixesFetched: false,
});

export default function reducer(state = initialState, action) {
  return ({
    [FETCH_DISTRICS_LIST_REQUEST]: fetchDistrictRequest,
    [FETCH_DISTRICS_LIST_SUCCESS]: fetchDistrictSuccess,
    [FETCH_DISTRICS_LIST_FAILURE]: fetchDistrictFailure,
    [FETCH_PREFIXES_REQUEST]: fetchPrefixesRequest,
    [FETCH_PREFIXES_SUCCESS]: fetchPrefixesSuccess,
    [FETCH_PREFIXES_FAIL]: fetchPrefixesFail,
    [SET_CURRENT_DISTRICT]: setCurrentDistrict,
  }[action.type] || (s => s))(state, action);
}



// WEBPACK FOOTER //
// src/reducers/app.js